import { useMemo } from 'react';
import i18n from 'i18n';
import { useSelector } from 'react-redux';
import { getChannelsDataSelector, getFavoriteChannelsDataSelector } from 'reducers/channels/selectors';
import useLoadRecentChannels from 'hooks/data/useLoadRecentChannels';
import useLoadEPGDynamicCategories from 'hooks/data/useLoadEPGDynamicCategories';

const useLoadEPGData = () => {
  const channels = useSelector(getChannelsDataSelector);
  const favoriteChannels = useSelector(getFavoriteChannelsDataSelector);
  const { data: recentChannels, isLoading: isRecentChannelsLoading } = useLoadRecentChannels();
  const { data: dynamicCategories, isLoading: isDynamicCategoriesLoading } = useLoadEPGDynamicCategories();

  const categories = useMemo(() => {
    if (isRecentChannelsLoading || isDynamicCategoriesLoading) return [];

    const all = {
      // id should be a number
      id: 0,
      name: i18n.t('epg.allChannels'),
      channelIds: channels.map(({ id }) => id),
    };

    const favorite = {
      id: 1,
      name: i18n.t('epg.favoriteChannels'),
      channelIds: favoriteChannels.map(({ id }) => id),
    };

    const recent = {
      id: 2,
      name: i18n.t('epg.recentChannels'),
      channelIds: recentChannels?.map(({ id }) => id),
    };

    return [all, favorite, recent].concat(dynamicCategories);
  }, [
    channels,
    dynamicCategories,
    favoriteChannels,
    isDynamicCategoriesLoading,
    isRecentChannelsLoading,
    recentChannels,
  ]);

  return categories;
};

export default useLoadEPGData;
